<template>
  <b-row>
    <b-col cols="12">
      <b-card body-class="d-flex flex-column justify-content-between" class="min-card-height">
        <h6 class="text-left">Status</h6>
        <vendas-status :series="series" class="status-graph" v-if="series[0] != undefined"></vendas-status>

        <b-card class="text-center f-g mt-2 mb-2" v-if="series[0] == undefined">
          <i class="fa fa-hdd-o fa-custom-size"></i>
          <h6>Sem resultados para o filtro aplicado</h6>
        </b-card>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import VendasStatus from "../charts/VendasStatus";

export default {
  components: {
    VendasStatus,
  },
  props: ["series"],
};
</script>